import { useCallback, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import clsx from 'clsx';
import { useFormikContext, ErrorMessage } from 'formik';

import { TypeTransport } from '../../../utils/functions/mockTransport';
import { ValuesModel } from '..';
import { ParkingService } from '../../../services';
import { formatError, formatDate, snackbarUtils } from '../../../utils';

import { CarIcon, BusIcon, TaxiIcon } from '../../../assets/icons';
import useStyles from './styles';

interface TransportModel {
  title: string;
  value: TypeTransport;
  icon: string;
  alt: string;
}

const makeTransports = (): TransportModel[] => [
  { title: 'Transporte Público', value: "public", icon: BusIcon, alt: "bus-icon" },
  { title: 'Aplicativo ou Táxi', value: "app", icon: TaxiIcon, alt: "taxi-icon" },
  { title: 'Condução Própria', value: "private", icon: CarIcon, alt: "car-icon" },
];

const Transport = () => {
  const { values, setFieldValue } = useFormikContext<ValuesModel>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
  const classes = useStyles();

  const [haveParking, setHaveParking] = useState<boolean | null>(null);

  const [transports] = useState(makeTransports());

  useEffect(() => {
    const fetchParkings = async () => {
      try {
        const { data } = await ParkingService.list(formatDate(values.date.toString()), Number(values.building));
        if (data.length > 0) {
          setHaveParking(true);
          // snackbarUtils.info('Este prédio possui vagas');
        } else {
          setHaveParking(false);
          // snackbarUtils.warning('Este prédio não possui vagas');
        }
      } catch (error) {
        console.log(error.message);
        snackbarUtils.error(formatError(error));
      }
    }
    fetchParkings();
  }, [values.building, values.date])

  const handleParking = useCallback((need_parking: boolean) => setFieldValue('needParking', need_parking), [setFieldValue]);
  const handleTransport = useCallback((transport: TypeTransport) => {
    setFieldValue('transport', transport);
    if (transport === 'app' || transport === "public") handleParking(false);
  }, [setFieldValue, handleParking]);

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Typography variant="h3">Como pretende vir ao trabalho?</Typography>

      <Grid container item xs={12} spacing={2}>
        {transports.map((transport, index) => (
          <Grid key={transport.title} item xs={index === 2 ? 12 : 6} sm={4}>
            <Button
              data-cy={`${transport.value}-button`}
              onClick={() => handleTransport(transport.value)}
              className={clsx({
                [classes.button]: true,
                [classes.selectedButton]: transport.value === values.transport,
                "lastButton": index === 2 && isMobile,
              })}
            >
              <img src={transport.icon} alt={transport.alt} draggable="false" />
              <span>{transport.title}</span>
            </Button>
          </Grid>
        ))}
      </Grid>
      {/*{*/}
      {/*  <Box marginY={4}>*/}
      {/*    <ErrorMessage name="transport" />*/}
      {/*    {(!haveParking && values.transport === 'private') &&*/}
      {/*      <Typography>Este prédio não possui vagas.</Typography>}*/}
      {/*  </Box>*/}
      {/*}*/}

      {(values.transport === 'private' && haveParking) &&
        <Box mb={4} >
          <Typography variant="h4" className={classes.carSectionTitle}>
            Precisa de uma vaga no estacionamento?
          </Typography>
          <Grid container spacing={3}>
            <Grid container item xs={6} justify="flex-end">
              <Button
                variant={values.needParking ? "outlined" : "contained"}
                onClick={() => handleParking(false)}
                className={clsx({
                  [classes.parkingButton]: true,
                  [classes.selectedParkingButton]: !values.needParking
                })}
                disableElevation
              >
                Não
              </Button>
            </Grid>
            <Grid container item xs={6}>
              <Button
                variant={values.needParking ? "contained" : "outlined"}
                onClick={() => handleParking(true)}
                className={clsx({
                  [classes.parkingButton]: true,
                  [classes.selectedParkingButton]: values.needParking
                })}
                disableElevation
              >
                Sim
              </Button>
            </Grid>
          </Grid>
        </Box>
      }
    </Container>
  );
}

export default Transport;

